export default defineNuxtRouteMiddleware(to => {
  if (import.meta.server) return

  // console.group('[Client.Middleware.user-only]')

  const { checkAuth } = useAuth()

  // If not authenticated, save URL and redirect
  if (!checkAuth()) {
    // Save the full URL with filters before redirect
    const redirectCookie = useCookie('redirect_url')
    redirectCookie.value = to.fullPath

    console.log('Not authenticated, saving URL:', to.fullPath)
    return navigateTo('/signin')
  }

  // console.groupEnd()
})
